import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const TOGGLE_BAR_HEIGHT = 50;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const StickyToggleBar = styled.div`
  height: ${TOGGLE_BAR_HEIGHT}px;
  position: sticky;
  top: 0;
  z-index: 6;
  background-color: ${colors.base.alpha};
  border-bottom: 1px solid ${colors.shades.gamma13};
  padding-bottom: 14px;
`;

const FilterAndFeedRow = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-height: 0;
`;

export {
  TOGGLE_BAR_HEIGHT,
  Container,
  StickyToggleBar,
  FilterAndFeedRow,
};
